import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const WaterDrop = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 104 104"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            { props.BgColor ? <rect width="104" height="104" rx="50" fill="#0076A8" /> : null }
            <path fillRule="evenodd" clipRule="evenodd" d="M52.0004 23.2002C52.6624 23.2002 53.2711 23.5637 53.5851 24.1466L69.664 53.9971C76.3936 66.4905 66.4932 80.8002 52.0004 80.8002C37.5075 80.8002 27.6071 66.4905 34.3367 53.9971L50.4156 24.1466C50.7296 23.5637 51.3383 23.2002 52.0004 23.2002ZM52.0004 28.7958L37.5061 55.7043C32.2829 65.4011 39.766 77.2002 52.0004 77.2002C64.2347 77.2002 71.7178 65.4011 66.4946 55.7043L52.0004 28.7958ZM43.0004 59.2002C43.9945 59.2002 44.8004 60.0061 44.8004 61.0002C44.8004 62.8954 44.8343 64.6932 45.5103 66.0452C45.8174 66.6593 46.2523 67.1602 46.912 67.5267C47.5907 67.9038 48.62 68.2002 50.2004 68.2002C51.1945 68.2002 52.0004 69.0061 52.0004 70.0002C52.0004 70.9943 51.1945 71.8002 50.2004 71.8002C48.1807 71.8002 46.51 71.4216 45.1637 70.6737C43.7984 69.9152 42.8833 68.8411 42.2904 67.6552C41.1979 65.4703 41.1994 62.8563 41.2003 61.1461C41.2003 61.0967 41.2004 61.048 41.2004 61.0002C41.2004 60.0061 42.0062 59.2002 43.0004 59.2002Z"
            fill={props.color ? props.color: "white"} />

        </SvgStyled>
    );
};

export default WaterDrop;
